import { render } from 'preact'
import TranslationForm from './TranslationForm'

const exp = options => {
  render(
    <TranslationForm {...options} />, document.querySelector(options.el)
  )
}
module.exports = exp
